// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7898":"44532038f99aab31","9626":"8537189b2952c43c"}[chunkId] + ".css";
};